// mport { spark, krystals, synergy, portal } from '../../testdata'
// import KrystalsCard from '../collections/navigationCards/KrystalsCard'
// import PortalCard from '../collections/navigationCards/PortalCard'
import SparkCard from '../collections/navigationCards/SparkCard'
// import SynergyCard from '../collections/navigationCards/SynergyCard'

const Resources = ({ tab, setTab, sparks, krystals, synergy, portals }) => {
  return (
    <>
      <div className="flex justify-center mb-10">
        <div className="flex justify-around w-[600px] ">
          <button
            onClick={() => {
              setTab('spark')
            }}
            className={` text-xl ${
              tab === 'spark' ? 'text-[#00FFF0]' : 'text-white'
            }`}
          >
            SPARK
          </button>
          <div className="w-[2px] h-[32px] bg-[#AD945F]"></div>
          <button
            onClick={() => {
              setTab('krystals')
            }}
            className={`text-xl ${
              tab === 'krystals' ? 'text-[#00FFF0]' : 'text-white'
            }`}
          >
            KRYSTALS
          </button>
          <div className="w-[2px] h-[32px] bg-[#AD945F]"></div>
          <button
            onClick={() => {
              setTab('synergy')
            }}
            className={`text-xl ${
              tab === 'synergy' ? 'text-[#00FFF0]' : 'text-white'
            }`}
          >
            SYNERGY
          </button>
          <div className="w-[2px] h-[32px] bg-[#AD945F]"></div>
          <button
            onClick={() => {
              setTab('portal')
            }}
            className={`text-xl ${
              tab === 'portal' ? 'text-[#00FFF0]' : 'text-white'
            }`}
          >
            PORTAL
          </button>
        </div>
      </div>

      <div className="flex flex-row flex-wrap w-full justify-evenly gap-3 collection-wrapper">
        <>
          <>
            {sparks && tab === 'spark' // Static data
              ? sparks.map((item, _) => (
                  <SparkCard
                    width={'230px'}
                    key={`${item.name}-Galaktika-${_}`}
                    // id={id}
                    image={item.card.image}
                    video={item.card.video}
                    name={item.name}
                    notInUserWallet={item.card.quantity <= 0}
                    rarities={item.rarities}
                  />
                ))
              : ''}
          </>
          <>
            {krystals && tab === 'krystals' // Static data
              ? krystals.map((item, _) => (
                <SparkCard
                    width={'230px'}
                    key={`${item.name}-Galaktika-${_}`}
                    // id={id}
                    image={item.card.image}
                    video={item.card.video}
                    name={item.name}
                    notInUserWallet={item.card.quantity <= 0}
                    rarities={item.rarities}
                  />
                ))
              : ''}
          </>
          <>
            {synergy && tab === 'synergy' // Static data
              ? synergy.map((item, _) => (
                <SparkCard
                    width={'230px'}
                    key={`${item.name}-Galaktika-${_}`}
                    // id={id}
                    image={item.card.image}
                    video={item.card.video}
                    name={item.name}
                    notInUserWallet={item.card.quantity <= 0}
                    rarities={item.rarities}
                  />
                ))
              : ''}
          </>
          <>
            {portals && tab === 'portal' // Static data
              ? portals.map((item, _) => (
                <SparkCard
                    width={'230px'}
                    key={`${item.name}-Galaktika-${_}`}
                    // id={id}
                    image={item.card.image}
                    video={item.card.video}
                    name={item.name}
                    notInUserWallet={item.card.quantity <= 0}
                    rarities={item.rarities}
                  />
                ))
              : ''}
          </>
        </>
      </div>
    </>
  )
}

export default Resources
